var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "raft-field-group"
  }, [_vm.groupType === 'accordion_item' ? _c('accordion-form-fields', {
    class: _vm.groupConfig.format_settings.classes,
    attrs: {
      "id": _vm.groupId,
      "label": _vm.groupLabel,
      "collapsed": _vm.groupConfig.collapsed
    },
    scopedSlots: _vm._u([{
      key: "accordionFormFields",
      fn: function () {
        return [_vm._t("default")];
      },
      proxy: true
    }], null, true)
  }) : _vm.groupType === 'details' ? _c('details-field-group', {
    attrs: {
      "id": _vm.groupId,
      "label": _vm.groupLabel,
      "collapsed": _vm.disabled,
      "required": _vm.required
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_vm._t("default")];
      },
      proxy: true
    }], null, true)
  }) : _vm.groupType === 'fieldset' ? _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.groupLabel))]), _vm._v(" "), _vm._t("default")], 2) : _vm.groupType === 'html_element' ? _c(_vm.dynamicComponent, {
    tag: "component",
    attrs: {
      "tag": _vm.groupConfig.format_settings.element,
      "class-name": _vm.groupConfig.format_settings.classes,
      "id": _vm.groupConfig.format_settings.id
    }
  }, [_vm.showGroupLabel(_vm.groupConfig) ? [_c(_vm.groupConfig.format_settings.label_element, {
    tag: "component"
  }, [_vm._v("\n        " + _vm._s(_vm.groupLabel) + "\n      ")])] : _vm._e(), _vm._v(" "), _vm._t("default")], 2) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }